import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  grid: {
    display: 'block',
    whiteSpace: 'pre-wrap',
  },
}));
